import {
	Checkbox as StyledCheckbox,
	type CheckboxProps as StyledCheckboxProps,
} from 'components/FormUi';

import { useValidatedController } from './hooks';

interface Props extends StyledCheckboxProps {
	defaultChecked?: boolean;
	name: string;
	requiredErrorMessage?: string;
}

export default function Checkbox({
	defaultChecked = false,
	disabled,
	name,
	required,
	requiredErrorMessage,
	...rest
}: Props) {
	const { errorMessage, invalid, onBlur, onChange, valid, value } =
		useValidatedController({
			name,
			requiredErrorMessage,
			required,
			defaultValue: defaultChecked,
			disabled,
		});

	return (
		<StyledCheckbox
			onChange={onChange}
			onBlur={onBlur}
			value="1"
			checked={value}
			invalid={invalid}
			valid={valid}
			errorMessage={errorMessage}
			disabled={disabled}
			{...rest}
		/>
	);
}
Checkbox.displayName = 'ReactHookForm_Checkbox';
